import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import Icon from "../icons";
import { SelectBoxProps, OptionProps } from "./types";

export const SelectBox = <T,>({
  value,
  onChange,
  children,
  header,
  headerPlaceholder,
  buttonRef,
  spaced,
  error = false,
  disabled = false,
  anchor = "bottom start",
}: SelectBoxProps<T>) => {
  return (
    <div className="relative">
      <Listbox value={value} onChange={onChange} disabled={disabled}>
        <ListboxButton
          className={`bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark min-h-10 items-center rounded-md px-3 ${spaced ? "py-1.5" : "py-1"} flex flex-row
          justify-between w-full border dark:border-blueBorderDark ${error ? "border-red" : ""}`}
          ref={buttonRef}
        >
          {({ open }) => (
            <div className="flex items-center w-full justify-between">
              <div className="truncate mr-2">{value ? header : headerPlaceholder}</div>
              <div>
                <Icon name={open ? "chevronUpIcon" : "chevronDownIcon"} size="xxxsmall" />
              </div>
            </div>
          )}
        </ListboxButton>
        <ListboxOptions
          anchor={anchor}
          className="bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark rounded-md border dark:border-blueBorderDark drop-shadow-lg border-greyBorder mt-1 absolute z-30 max-h-96! overflow-y-auto! overflow-x-hidden!"
        >
          {children}
        </ListboxOptions>
      </Listbox>
    </div>
  );
};

export const SelectOption = <T,>({ selectKey, value, children, spaced, disabled }: OptionProps<T>) => (
  <ListboxOption
    key={selectKey}
    value={value}
    disabled={disabled}
    className="flex cursor-pointer border-b dark:border-blueBorderDark last:border-0 min-h-10 items-center"
  >
    {({ focus, selected }) => (
      <div
        key={selectKey}
        className={`flex items-center space-x-1 w-full pl-5 pr-8 ${spaced ? "py-2.5" : "py-2"} ${focus && "bg-blueHover dark:bg-blueHoverDark"} ${
          selected && "bg-beige dark:bg-gray-700"
        } ${disabled && "cursor-default"}`}
      >
        {children}
      </div>
    )}
  </ListboxOption>
);
